
import { Collapse } from 'antd';
import { useEffect, useMemo, useState } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMinus, faPlus } from '@fortawesome/free-solid-svg-icons';
import './index.css';

const Accordion = ({ children, keyPrefix = "", defaultActiveKey, usePanelHash = true, separateSections, ...restProps }) => {
  const history = useHistory();
  const location = useLocation();
  const [activeKey, setActiveKey] = useState(defaultActiveKey);

  useEffect(() => {
    const key = (location.hash)
      ? location.hash.replace("#", "").split(",").filter(key => key.startsWith(keyPrefix))
      : defaultActiveKey;

    if (Array.isArray(key) && defaultActiveKey) key.push(defaultActiveKey);
    if (key) setActiveKey(key);
  },
    // eslint-disable-next-line
    []
  );

  const classNames = useMemo(() => {
    const classNames = ['bccampus-accordion']
    if (separateSections === true) classNames.push('separate')
    return classNames.join(' ');
  }, [separateSections]);

  const onChange = (keys) => {
    setActiveKey(keys);
    const lastKey = Array.isArray(keys) ? keys[keys.length - 1] : keys;
    if (usePanelHash && lastKey) history.replace(`#${lastKey}`)
  }

  return (
    <Collapse
      className={classNames}
      expandIconPosition="end"
      expandIcon={panelProps => {
        return <FontAwesomeIcon icon={panelProps.isActive ? faMinus : faPlus} />;
      }}
      defaultActiveKey={defaultActiveKey}
      activeKey={activeKey}
      onChange={onChange}
      {...restProps}
    >
      {children}
    </Collapse>
  );
};

Accordion.Panel = ({ children, ...restProps }) => {
  return (
    <Collapse.Panel {...restProps}>
      {children}
    </Collapse.Panel>
  );
};

export default Accordion;
